var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6621 8.13243H4.04866L10.4011 2.70386C10.5027 2.61636 10.441 2.45386 10.3068 2.45386H8.70144C8.63069 2.45386 8.56358 2.47886 8.51097 2.5235L1.65607 8.37886C1.59328 8.43243 1.54293 8.49867 1.50842 8.57307C1.47391 8.64748 1.45605 8.72831 1.45605 8.81011C1.45605 8.8919 1.47391 8.97274 1.50842 9.04714C1.54293 9.12155 1.59328 9.18778 1.65607 9.24136L8.55088 15.1324C8.57809 15.1556 8.61074 15.1681 8.6452 15.1681H10.305C10.4392 15.1681 10.5009 15.0039 10.3993 14.9181L4.04866 9.48957H14.6621C14.7419 9.48957 14.8072 9.42529 14.8072 9.34671V8.27529C14.8072 8.19671 14.7419 8.13243 14.6621 8.13243Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.edd4457ec5e94fe2145143f4ce1f2858.svg";
export { ForwardRef as ReactComponent };